<div class="ai-token-modal token-restock-container">
  <div class="logo-container mt-2">
    <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" class="main-logo" width="200">
  </div>

  <h2 class="modal-title mt-3">You are out of World Initialization Credits</h2>

  <p class="description text-center">
    Add a Credit to start a fresh world generation.
  </p>

  <div class="purchase-section mt-4 w-100">
    <h3 class="text-center text-white fw-bold mb-3 purchase-title text-uppercase">Purchase</h3>
    @if (isLoading) {
      <div class="d-flex justify-content-center align-items-center w-100" style="min-height: 100px;">
        <div class="spinner-border text-light" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }

    @if (!isLoading) {
      <div class="cards-container">
        <!-- World Initialization Card(s) -->
        @for (product of tokenPacks; track product) {
          <div class="purchase-card world-intialization" (click)="buyProduct(product.id)">
            <div class="card-inner">
              <h5 class="fw-bold px-1">{{product.name}}</h5>
              <p class="small mb-0">{{product.description}}</p>
            </div>
            <div class="price-tag fw-bold">${{product.price}}</div>
          </div>
        }
      </div>
    }
  </div>

  <div class="action-btn text-center mt-4 mb-2">
    <button type="button" class="btn btn-dark px-5" (click)="closeModal()">Back</button>
  </div>
</div>
